import * as React from "react"

type Props = {
    children: React.ReactNode
}

const RightAlignHeaderCell = (props: Props) => {
    return (
        <div className="rightAlignHeaderCell">
            <style jsx={true}>
                {`
                    .rightAlignHeaderCell {
                        float: right;
                        padding-left: 0.5rem;
                    }
                `}
            </style>
            {props.children}
        </div>
    )
}

export default RightAlignHeaderCell
